import type { AdId } from '../types';

const nonBannerAds: AdId[] = ['datasheet', 'itinerary-results-loading', 'poi-list', 'traffic'];

export function getReworldDivId(adId: AdId) {
	if (nonBannerAds.includes(adId)) {
		return 'div-gpt-ad-mpu_haut';
	}

	if (adId === 'map-banner') {
		return 'div-gpt-ad-masthead_haut';
	}

	// By default, return the ad ID
	return adId;
}

export function getReworldTargeting(adId: AdId) {
	if (nonBannerAds.includes(adId)) {
		return { pos: '2' };
	}

	if (adId === 'map-banner') {
		return { pos: '1' };
	}
}
